/**
 * SPEZ-PATCH P2-G §3 (On-hold): deutsche Grund-Beschriftungen für die Web-Sicht
 * (Auftragsdetail, Auftragsliste, Plantafel). Vollanalyse S1: Die Map lebt
 * kanonisch in @werkbank/shared — API-Feed (activity.service) und
 * Auftraggeber-Mail (hold.dto/hold.service) nutzen dieselbe Quelle; hier nur
 * Re-Export plus Fallback-Helfer.
 */
import { HOLD_REASON_LABELS } from '@werkbank/shared';

export { HOLD_REASON_LABELS };

/** Grund → Label mit Fallback auf den Rohwert (falls je ein Grund hinzukommt). */
export function holdReasonLabel(reason: string | null | undefined): string {
  if (!reason) return '';
  return HOLD_REASON_LABELS[reason] ?? reason;
}
